<template>
  <div class="page-container f-full">
    <div v-if="title" class="title">
      <span>{{ title }}</span>
      <slot name="titleExtra" />
    </div>
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    title: {
      type: String,
      default: ''
    }
  }
});
</script>

<style scoped lang="less">
.page-container {
  height: 100%;
  overflow-y: auto;
  min-width: 1094px;
  position: relative;
  padding: 32px;
  .title {
    font-weight: bold;
    font-size: 18px;
    color: var(--active-font-color);
    line-height: 29px;
    display: flex;
    margin-bottom: 24px;
  }
}
</style>
